/* eslint-disable */ 
import React from 'react'
import styles from '../../../../containers/Forms/Forms.css'

const TextInput = props => {
  const {
    input,
    meta: { touched, error, warning },
    label,
    getLabel,
    required,
    autoFocus,
    placeholder,
    disabled,
    inline,
    showRedRequiredIcon,
    type = 'text',
  } = props

  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const cn = inline ? styles.inputRowGroup : styles.inputGroup

  return (
    <label
      className={cn}
      htmlFor={input.name}
    >
      {required &&
        <span className={styles.required} />
      }
      {showRedRequiredIcon &&
        <span className={styles.required} />
      }
      {inputComponent}
      <input
        {...input}
        autoComplete="off"
        className={styles.input}
        type={type}
        disabled={disabled}
        required={required}
        id={input.name}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
      {error && <span className={styles.error}>{error}</span>}
    </label>
  )
}

export default TextInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/TextInput/TextInput.jsx